import { getPrefetchedUserData } from '~domains/auth';

import { getRegisteredQueryClient } from '~shared/lib/query-client-registry';

import { getAnalyticsUserRole } from './get-analytics-user-role';

type UserAmpliProps = {
  person_id?: string;
  role?: string;
};

export const getUserAmpliProps = (): UserAmpliProps | null => {
  const queryClient = getRegisteredQueryClient();

  if (!queryClient) {
    return null;
  }

  const data = getPrefetchedUserData(queryClient);

  if (!data) {
    return null;
  }

  return {
    person_id: data.personId,
    role: getAnalyticsUserRole(data),
  };
};
